module.exports = __webpack_public_path__ + "img/thanks_zh.78fc94aa.png";